import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';
import { listNP } from '../../../modules/empModule/empHr';
import NpForm from '../../../components/employeemng/np/NpForm';



const NpFormContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    attrVal1: '',
    attrVal2: '',
    attrVal3: '',
    attrVal4: '',
    attrVal5: '',
  };

  const validationSchema = yup.object({
    attrVal1: yup.string('').required('과제번호를 입력하세요'),
    attrVal2: yup.string().required('과제명을 입력하세용'),
    attrVal3: yup.string().required('수행기간을 입력하세요'),
    attrVal4: yup.string().required('참여기간을 입력하세요'),
    attrVal5: yup.string().required('참여비율을 입력하세요'),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: employee.usrUuid,
        infoTyp: 'NP',
        attrVal1: values.attrVal1,
        attrVal2: values.attrVal2,
        attrVal3: values.attrVal3,
        attrVal4: values.attrVal4,
        attrVal5: values.attrVal5,
      };

      //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

      try {
        const response = await employeeApi.addResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listNP({
              id: employee.usrUuid,
              infoTyp: 'NP',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <NpForm formik={formik} />;
};

export default NpFormContainer;
